import { computed } from 'vue'
import { useStore } from 'vuex'
import { format } from 'date-fns'

import { CURRENCIES } from '@/config'

export const DATA_LAYER_EVENTS = {
  ECOMMERCE: {
    VIEW_ITEM: 'view_item',
    ADD_TO_CART: 'add_to_cart',
    PURCHASE: 'purchase'
  }
}

export default function useDataLayer() {
  const store = useStore()

  const booking = computed(() => store.state.booking)
  const generalSettings = computed(() => store.state.app.generalSettings)

  const clearEcommerce = () => {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ ecommerce: null })
    }
  }

  const pushEcommerce = (event) => {
    const { product, option, order } = booking.value

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      const currency = CURRENCIES[generalSettings.value.currency.value] || ''

      const price = option.price['price_tier_slot'].price
      const value = price * order.amountPeople

      const ecommerce = {
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            currency,
            item_category: product.type,
            item_category2: `${option.duration} min`,
            item_variant: option.title,
            price: Number(price),
            quantity: Number(order.amountPeople)
          }
        ]
      }

      if (event === DATA_LAYER_EVENTS.ECOMMERCE.ADD_TO_CART) {
        ecommerce.value = Number(value)
        ecommerce.currency = currency
      }

      if (event === DATA_LAYER_EVENTS.ECOMMERCE.PURCHASE && order.id) {
        ecommerce.transaction_id = `${format(order.date, 'yyMMdd')}_${order.id}`
        ecommerce.value = Number(value)
        ecommerce.currency = currency
      }

      window.dataLayer.push({ event, ecommerce })
    }
  }

  return { clearEcommerce, pushEcommerce }
}
